const Test = () => import("@/views/medical/Test");

const routes = [
    {
        path: "/network/test",
        name: "test",
        meta: {
            title: "test"
        },
        component: Test
    },
];
export default routes;
